<script setup>
import { computed } from 'vue';
import { t } from '../i18n';

const props = defineProps({
	query: { type: String, default: '' },
});

const searchMessage = computed(() => t.noDealersNear(props.query || t.yourSearch));
</script>

<template>
	<div class="dealer-locator__empty empty-locator">

		<div class="empty-locator__header">
			<span class="empty-locator__icon" aria-hidden="true"></span>
			<h2 class="empty-locator__title">{{ t.noDealersFound }}</h2>
			<p class="empty-locator__text">{{ searchMessage }}</p>
		</div>

		<div class="empty-locator__info">
			<p class="empty-locator__hint">{{ t.tryTheseSteps }}</p>
			<ul class="empty-locator__list">
				<li>{{ t.checkSpelling }}</li>
				<li>{{ t.expandRadius }}</li>
			</ul>
		</div>

	</div>
</template>
